export const FAQS_KEY = 'faqs'
export const PROMOTIONS_KEY = 'promotions'
export const SERIES_KEY = 'series'
export const TERM_KEY = 'term'
export const VIDEOS_KEY = 'video'
export const ACTIONS_SETTINGS_KEY = Symbol('settings')
